var _path;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var SvgUpdateDataIcon = function SvgUpdateDataIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 28V26H24V28H10ZM10 20V18H32V20H10ZM10 12V10H32V12H10ZM26.4615 38V33.581L37.127 22.9655C37.3243 22.7678 37.528 22.6345 37.738 22.5655C37.948 22.4962 38.158 22.4615 38.368 22.4615C38.597 22.4615 38.822 22.5045 39.043 22.5905C39.2643 22.6762 39.4653 22.805 39.646 22.977L41.496 24.8655C41.6603 25.0628 41.7853 25.268 41.871 25.481C41.957 25.6937 42 25.9063 42 26.119C42 26.332 41.959 26.5468 41.877 26.7635C41.795 26.9802 41.668 27.1872 41.496 27.3845L30.881 38H26.4615ZM28.231 36.231H30.131L37.0655 29.2845L36.127 28.3345L35.2155 27.3575L28.231 34.331V36.231ZM36.127 28.3345L35.2155 27.3575L37.0655 29.2845L36.127 28.3345Z",
    fill: "#13C450"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpdateDataIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/update-data-icon.849d99e3.svg";
export { ForwardRef as ReactComponent };